import React from 'react';
import Styles from './module-item-styles.scss';
import classNames from 'classnames';
import { BlockIcon } from '@/presentation/components/icons';
import { CircleNextButton, ProgressBarSimple } from '@/presentation/components';
const ModuleItem = ({ title = 'ModuleItem', backgroundColor = 'blue', type = 'blocked', module, onClick }) => {
    const changeIconColorByBackground = (backgroundColor) => {
        switch (backgroundColor) {
            case 'purple':
                return '#695CFF';
            case 'red':
                return '#F04A4A';
            case 'orange':
                return '#F48218';
            case 'blue':
                return '#2AB1EB';
            default:
                return '#2AB1EB';
        }
    };
    function parsePercent(num) {
        try {
            if (num === 100)
                return num.toFixed(1);
            return num.toFixed(2);
        }
        catch (error) {
            return num;
        }
    }
    return (React.createElement("div", { className: classNames([Styles.moduleItemWrap, Styles[backgroundColor]]) },
        React.createElement("div", { className: Styles.score },
            React.createElement("div", { className: Styles.scoreContent }, type === 'blocked' ? (React.createElement("div", { className: Styles.logo },
                React.createElement(BlockIcon, { color: changeIconColorByBackground(backgroundColor) }))) : (React.createElement("div", { className: Styles.text },
                React.createElement("div", { className: Styles.title }, "Score"),
                React.createElement("div", { className: Styles.value },
                    module.score,
                    "%"))))),
        React.createElement("div", { className: Styles.subTitle }, module.moduleTitle),
        React.createElement("div", { className: Styles.title }, module.title),
        React.createElement("div", { className: Styles.content }, module.completed ? (React.createElement("div", { className: Styles.progressContainer },
            React.createElement("div", { className: Styles.bar },
                React.createElement(ProgressBarSimple, { percentage: parsePercent(module.progress) })),
            React.createElement("div", { className: Styles.icon },
                React.createElement(CircleNextButton, { onClick: onClick })))) : (React.createElement("p", { className: Styles.description }, module.description)))));
};
export default ModuleItem;
